import { render, staticRenderFns } from "./VehicleModelAutocomplete.vue?vue&type=template&id=b5873c2a&scoped=true"
import script from "./VehicleModelAutocomplete.vue?vue&type=script&lang=ts"
export * from "./VehicleModelAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5873c2a",
  null
  
)

export default component.exports